import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { MentoringApiService } from '@app/mentoring/services/mentoring-api.service';
import { Mentorship } from '@app/mentoring/mentoring-api.model';
import { TranslateService } from '@ngx-translate/core';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';
import { OpportunityViewService } from '@app/opportunities/services/opportunity-view.service';
import { TrackerService } from '@app/shared/services/tracker.service';
import { MentoringTrackingService } from '@app/mentoring/services/mentoring-tracking.service';

@Component({
  selector: 'dgx-mentoring',
  templateUrl: './mentoring.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MentoringComponent implements OnInit {
  public isLoading = true;
  public isSorting = false;
  public mentees: Mentorship[] = [];
  public mentors: Mentorship[] = [];
  public noItemsImage = this.getEmptyImageUrl();

  public i18n = this.translate.instant([
    'Core_Empty_Image_Alt',
    'Opportunities_NoMentorship',
  ]);

  constructor(
    private cdr: ChangeDetectorRef,
    private mentoringApiService: MentoringApiService,
    private mentoringTrackingService: MentoringTrackingService,
    private opportunityViewService: OpportunityViewService,
    private trackerService: TrackerService,
    private translate: TranslateService,
    private webEnvironmentService: WebEnvironmentService
  ) {
    this.opportunityViewService.updatePageTitle(
      this.translate.instant('Opportunities_Mentoring') +
        ' | ' +
        this.translate.instant('Core_Opportunities')
    );
  }

  public ngOnInit(): void {
    this.trackerService.setLocation('Opportunity Mentoring');

    this.mentoringApiService
      .getUserMentorships()
      .subscribe(({ mentors, mentees }) => {
        this.isLoading = false;
        this.mentees = mentees;
        this.mentors = mentors;

        this.mentoringTrackingService.mentoringImpressed(
          this.mentees ? this.mentees.length : 0,
          this.mentors ? this.mentors.length : 0
        );

        this.cdr.markForCheck();
      });
  }

  public onMenteesUpdate(mentees: Mentorship[]): void {
    this.mentees = mentees;
    this.cdr.detectChanges();
  }

  public onMentorsUpdate(mentors: Mentorship[]): void {
    this.mentors = mentors;
    this.cdr.detectChanges();
  }

  private getEmptyImageUrl(): string {
    return this.webEnvironmentService.getBlobUrl(
      '/content/img/emptystate/empty-search-results.svg',
      true
    );
  }
}
